<h2 class="first_title">Gestione Documenti</h2>
<div export-help [pageNumber]="'196'"></div>
<div class="content-page-wrapper">

  <div class="standardpanel">
    <label for="">Ordina per data creazione</label>
    <select class="form-control card-order" [(ngModel)]="selectOrder" name="ordina-per" id="">
      <option value="DESC" [selected]="true">Decrescente</option>
      <option value="ASC">Crescente</option>
    </select>
    <div *ngIf="filterFields" class="filters">
      <app-dynamic-form [questions]="filterFields" [config]="formConfiguration" (onFormSubmit)="onFilterSubmission($event)"
                        (onFormReset)="onFilterReset($event)" [inline]="true">
      </app-dynamic-form>
    </div>
  
    <div class="card-list" *ngIf="uploadedElaborations.length > 0">
      <div class="card-list-item" *ngFor="let elaboration of uploadedElaborations">
        <app-document-status-card (onCardDelete)="onRemoveElaboration($event, elaboration.titolo)"
                                  [id]="elaboration.idElaborazione" [title]="elaboration.titolo | titlecase"
                                  [date]="elaboration.dataCreazione | date: 'dd/MM/yyyy, HH:mm'" [status]="elaboration.stato.label">
        </app-document-status-card>
      </div>
    </div>
  
    <div class="message-no-items" *ngIf="noElaborationsLoaded">
      <span>Non sono presenti elaborazioni</span>
    </div>
  
  
  
    <div class="card-pagination" *ngIf="elaborationResponse">
      <app-pagination
        [totalItems]="elaborationResponse.numeroElaborazioniTotali"
        [resetCurrentPage]="resetCurrentPage"
        [hasAutoRefresh]="true"
        (refreshEvent)="onRefresh($event)">
      </app-pagination>
    </div>
  </div>
</div>

